import * as React from "react";

import { BlockView } from "common/views/block/BlockView.view";
import { FragmentLayout } from "core/components/FragmentLayout";
import { IQueryOne, QueryOne } from "core/decorators/QueryOne";
import { IPanelProps, Panel } from "../../core/decorators/Panel";
import User from "./entities/User";
import UserDetailsConfig from "./UserDetailsConfig";
import * as fragments from "./userFragments";
import { IUserFragmentProps } from "./userFragments";


@Panel({ id: "user-details", configClass: UserDetailsConfig })
@QueryOne(User)
class UserDetailsPanel extends React.Component<IPanelProps<UserDetailsConfig> & IQueryOne<User, {}>> {

	public render() {
		const { config, queryEntity } = this.props;

		if (!queryEntity) {
			return null;
		}

		const props: IUserFragmentProps = {
			user: queryEntity,
			selectedPropId: config.propertyIds
		};

		return (
			<BlockView viewKey="block">
				<FragmentLayout layout={config.layout} fragments={fragments} props={props} />
			</BlockView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/userDetails/UserDetails.panel.tsx